// Cross-stack domain enum value lists (selects, filters).
// Moved from `src/types/enums.ts`; the app re-exports them so consumers are
// untouched.

import type {
  PriceType, VatRateCode, BorderType,
  PaymentMethod,
  InvoiceReviewStatus,
  TransactionStatus, GDStatus, CompanyCategory, TransportType,
  DocumentType, DocumentStatus, ReviewStatus, EmployeeRole,
  ContactPurpose, CommentTag, GTUCode, CompanyDocumentType,
  CommissionType,
  EmploymentType,
  PriceListRequestStatus,
} from '@shared/types.ts';

// ============================================
// VALUES ARRAYS (FE-only — selects, filters)
// ============================================

export const COMMENT_TAG_VALUES: CommentTag[] = ['cancellation_reason', 'price_change', 'system_note', 'transport_instructions'];
export const VAT_RATE_CODE_VALUES: VatRateCode[] = ['23', '8', '5', '0', 'zw', 'np'];
export const INVOICE_REVIEW_STATUS_VALUES: InvoiceReviewStatus[] = ['pending', 'approved', 'rejected', 'partial', 'request_correction'];
export const CATEGORY_VALUES: CompanyCategory[] = ['recycler', 'transporter', 'waste_generator', 'exporter', 'importer', 'organizacja_odzysku', 'commercial', 'other'];
export const GTU_CODE_VALUES: GTUCode[] = [
  'GTU_01', 'GTU_02', 'GTU_03', 'GTU_04', 'GTU_05', 'GTU_06', 'GTU_07',
  'GTU_08', 'GTU_09', 'GTU_10', 'GTU_11', 'GTU_12', 'GTU_13'
];
export const STATUS_VALUES: TransactionStatus[] = ['cancelled'];
export const TRANSPORT_TYPE_VALUES: TransportType[] = ['truck', 'train', 'ship', 'spedition'];
export const PRICE_TYPE_VALUES: PriceType[] = ['per_ton', 'flat_rate'];
export const GD_STATUS_VALUES: GDStatus[] = ['yes', 'no', 'na'];
export const BORDER_TYPE_VALUES: BorderType[] = ['domestic', 'eu', 'non_eu'];
export const DOCUMENT_TYPE_VALUES: DocumentType[] = ['ie529', 'ie599', 'cmr', 'annex7', 'weight_tickets', 'transport_order', 'transport_invoice', 'waste_image', 'other'];
export const DOCUMENT_STATUS_VALUES: DocumentStatus[] = ['original', 'copy', 'generated'];
export const REVIEW_STATUS_VALUES: ReviewStatus[] = ['pending', 'approved', 'not_approved', 'not_applicable'];
export const EMPLOYEE_ROLE_VALUES: EmployeeRole[] = ['admin', 'management', 'sales', 'administration', 'logistics', 'developer'];
export const CONTACT_PURPOSE_VALUES: ContactPurpose[] = ['transport_notification', 'on_annex_doc', 'sales', 'invoicing', 'weight_confirmation', 'edpr'];
export const PAYMENT_METHOD_VALUES: PaymentMethod[] = ['transfer', 'cash', 'card', 'compensation', 'other'];
export const COMPANY_DOCUMENT_TYPE_VALUES: CompanyDocumentType[] = [
  'green_contract', 'recycler_decision', 'collector_decision',
  'insurance', 'permit', 'recycling_percentage_certificate', 'other',
];
export const CURRENCY_VALUES = ['PLN', 'EUR', 'USD'] as const;
export const INCOTERMS_VALUES = ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DAP', 'DPU', 'DDP'] as const;
export const PRICE_LIST_REQUEST_STATUS_VALUES: PriceListRequestStatus[] = ['new', 'done'];

// ── Commission ─────────────────────────────────────────────────────────
export const COMMISSION_TYPE_VALUES: CommissionType[] = ['percentage', 'per_ton', 'flat_rate'];
export const EMPLOYMENT_TYPE_VALUES: EmploymentType[] = ['employment', 'b2b'];
